(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("charts", [], factory);
	else if(typeof exports === 'object')
		exports["charts"] = factory();
	else
		root["charts"] = factory();
})(this, function() {
return 